import styled from 'styled-components';

type InputType = {
  $hideSearchIcon?: boolean;
  $hasLabel?: boolean;
};

export const CustomInputLeftElement = styled.div<InputType>`
  width: 15px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  pointer-events: none;
  top: 0px;
  left: 12px;
  z-index: 2;
  transition: margin-left 0.3s ease, opacity 0.3s ease;
  opacity: ${(props) => (props.$hideSearchIcon ? 0 : 1)};
  margin-left: ${(props) => (props.$hideSearchIcon ? '-21px' : '0px')};
  padding-top: ${(props) => (props.$hasLabel ? '16px' : '0px')};
`;

export const CustomInputGroup = styled.div<InputType>`
  position: relative;
  overflow: hidden;
`;

export const InputContainer = styled.div<InputType>`
  z-index: 1;

  & input {
    transition: padding-left 0.3s ease;
    padding-left: ${({ $hideSearchIcon }) => ($hideSearchIcon ? '12px' : '33px')};
  }
`;
